import Vue from 'vue'

Vue.filter('tableIndex', function(index, page) {
    return index + 1 + (page - 1) * 20
})
